export var loanTerm = {
  name: 'loanTerm',
  type: 'integer',
  minimum: 1,
  maximum: 30,
  format: 'number'
};
export var refinanceLoanTerm = {
  name: 'refinanceLoanTerm',
  type: 'integer',
  minimum: 1,
  maximum: 30,
  format: 'number'
};
export var currentLoanTerm = {
  name: 'currentLoanTerm',
  type: 'integer',
  minimum: 1,
  maximum: 30,
  format: 'number'
};
export var monthlyDebt = {
  name: 'monthlyDebt',
  type: 'integer',
  format: 'currency',
  minimum: 0
};
export var refinanceInterestRate = {
  name: 'refinanceInterestRate',
  type: 'float',
  minimum: 0.01,
  maximum: 1,
  format: 'percentage'
};
export var homeImprovementCost = {
  name: 'homeImprovementCost',
  type: 'integer',
  minimum: 0,
  maximum: 10000000,
  format: 'currency'
};
export var propertyTax = {
  name: 'propertyTax',
  type: 'integer',
  minimum: 0,
  maximum: 10000000,
  format: 'currency'
};
export var homeownersInsurance = {
  name: 'homeownersInsurance',
  type: 'integer',
  minimum: 0,
  maximum: 10000000,
  format: 'currency'
};
export var mortgageInsurance = {
  name: 'mortgageInsurance',
  type: 'integer',
  minimum: 0,
  maximum: 10000000,
  format: 'currency'
};
export var currentMortgageInterestRate = {
  name: 'currentMortgageInterestRate',
  type: 'float',
  format: 'percentage',
  minimum: 0.01,
  maximum: 1
};